export let BASE_URL = document.location.protocol + '//' + document.location.host;
let isFeature = false;
// Feature-branch previews (app.feature-<branch>.telepost.pw, see "deploy review"
// in .gitlab-ci.yml) have no backend of their own and use the dev API.
if (document.location.host.match(/^app\.feature-/)) {
  BASE_URL = 'https://app.dev.telepost.pw';
  isFeature = true;
}

if (localStorage.API_URL) {
  BASE_URL = localStorage.API_URL;
}

export const environment = {
  production: true,
  hmr: false,
  e2e: false,
  apiPath: BASE_URL + '/api',
  isFeature,
};
